<div class="doc-section">
    <div class="doc-card" #docCard>
        <style>
            .rol-page {
                font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                font-size: 9pt;
                font-weight: 400;
                line-height: 1.5;
                color: #000000;
            }

            .rol-header {
                background-color: #1a2c5b;
                padding: 0 28px;
                height: 42px;
                display: flex;
                align-items: center;
            }

            .rol-brand {
                font-size: 14pt;
                font-weight: 700;
                color: #ffffff;
                line-height: 1;
            }

            .rol-brand-accent {
                color: #f0b429;
            }

            .rol-gold-bar {
                height: 5px;
                background-color: #f0b429;
            }

            .rol-body {
                padding: 40px 80px;
            }

            .rol-title {
                text-align: center;
                font-weight: 700;
                font-size: 11pt;
                text-transform: uppercase;
                text-decoration: underline;
                color: #000000;
                margin-bottom: 2px;
            }

            .rol-subtitle {
                text-align: center;
                font-size: 9pt;
                color: #000000;
                margin-bottom: 12px;
            }

            .rol-info-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 18px;
                border: 1px solid #d1d9ea;
            }

            .rol-info-table td {
                padding: 7px 12px;
                border: 1px solid #d1d9ea;
                font-size: 9pt;
                width: 50%;
            }

            .rol-info-table td.lbl {
                background-color: #eef1f8;
                font-weight: 700;
                color: #000000;
            }

            .rol-info-table td.val {
                background-color: #ffffff;
                color: #000000;
                font-weight: 700;
                text-transform: capitalize;
            }

            .rol-p {
                margin-bottom: 6px;
                font-size: 9pt;
                color: #000000;
            }

            .rol-heading {
                font-weight: 700;
                font-size: 9pt;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.3px;
                margin-top: 14px;
                margin-bottom: 6px;
                padding-bottom: 3px;
                border-bottom: 1px solid #c7d4f0;
            }

            .rol-sub {
                margin-top: 4px;
                margin-bottom: 4px;
                color: #000000;
                font-size: 9pt;
            }

            .rol-bold {
                font-weight: 700;
                color: #000000;
            }

            .rol-ol {
                margin-left: 18px;
                margin-top: 6px;
                margin-bottom: 10px;
            }

            .rol-ol li {
                margin-bottom: 5px;
                font-size: 9pt;
                color: #000000;
                padding-left: 2px;
            }

            .rol-witness {
                text-align: center;
                margin-top: 14px;
                margin-bottom: 14px;
                padding: 10px;
                background-color: #f7f9fc;
                border: 1px solid #e2e8f0;
                font-size: 9pt;
                font-weight: 600;
                color: #000000;
                border-radius: 8px;
            }

            .rol-sig-block {
                margin-top: 14px;
                margin-bottom: 0;
                padding: 12px 14px;
                background-color: #fafbfd;
                border: 1px solid #e2e8f0;
                border-top: 3px solid #1a2c5b;
            }

            .rol-sig-block-heading {
                font-weight: 700;
                font-size: 8.5pt;
                text-transform: uppercase;
                letter-spacing: 1px;
                color: #000000;
                margin-bottom: 10px;
            }

            .rol-sig-table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 10px;
            }

            .rol-sig-table td {
                vertical-align: bottom;
                padding: 0;
            }

            .rol-sig-label {
                display: block;
                font-size: 7.5pt;
                font-weight: 700;
                color: #000000;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                margin-bottom: 3px;
            }

            .rol-sig-line {
                border-bottom: 1px solid #374151;
                height: 20px;
                display: block;
                width: 100%;
            }

            .rol-footer {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 8pt;
                color: #9ab0d8;
            }

            .rol-sig-canvas {
                display: block;
                width: 100%;
                height: 55px;
                border: 1.5px dashed #a0aec0;
                border-radius: 4px;
                background: #f8faff;
                cursor: crosshair;
                touch-action: none;
                transition: border-color 0.2s, background 0.2s;
            }

            .rol-sig-canvas:hover {
                border-color: #1a2c5b;
                background: #eef2ff;
            }

            .rol-sig-canvas.has-sig {
                border: 1.5px solid #1a2c5b;
                background: #f0f4ff;
                border-radius: 4px;
            }
        </style>

        <div class="rol-page">
            <div class="rol-header">
                <span class="rol-brand">E.A.S.Y. <span class="rol-brand-accent">Liens</span></span>
            </div>
            <div class="rol-gold-bar"></div>

            <div class="rol-body">
                <div class="rol-title">Release of Lien &amp; Authority to Distribute</div>
                <div class="rol-subtitle">({{ patientName }} / {{ providerName }})</div>

                <table class="rol-info-table">
                    <tr>
                        <td class="lbl">Patient</td>
                        <td class="val">{{ patientLast }}, {{ patientFirst }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Provider</td>
                        <td class="val">{{ providerName }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Date(s) of Service</td>
                        <td class="val">{{ dateOfService }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Account</td>
                        <td class="val">{{ accountNumber }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Full Billed Charges</td>
                        <td class="val">{{ billedCharges }}</td>
                    </tr>
                    <tr>
                        <td class="lbl">Trust Amount</td>
                        <td class="val">{{ trustAmount }}</td>
                    </tr>
                </table>

                <p class="rol-p">
                    This <span class="rol-bold">RELEASE OF LIEN &amp; AUTHORITY TO DISTRIBUTE</span>
                    (&ldquo;Release&rdquo;) is executed by {{ providerName }}
                    (&ldquo;Provider&rdquo;) and delivered to {{ attorneyName }}, as counsel for Patient, for reliance and action.
                </p>

                <div class="rol-heading">Release and Authorization</div>
                <div class="rol-sub">For good and valuable consideration, including prompt payment by <span class="rol-bold">E.A.S.Y. Liens, LLC</span> (&ldquo;Factor&rdquo;), Provider hereby:</div>
                <ol class="rol-ol">
                    <li><span class="rol-bold">ACCEPTS</span> the agreed-upon amount as payment in full of the Account, and in complete satisfaction
                        of any and all charges, balances, debts, liens and obligations arising from or related to the account
                        number and full billed charges set out above (the &ldquo;Account&rdquo;);</li>
                    <li><span class="rol-bold">RELEASES AND DISCHARGES</span> all liens, debts and claims against the Patient, the injury claim, and
                        any trust funds related to the Account;</li>
                    <li><span class="rol-bold">WAIVES</span> any right to seek additional payment from Patient related to the Account; and</li>
                    <li><span class="rol-bold">AUTHORIZES AND DIRECTS</span> Injury Counsel to release and distribute all monies being held in Trust,
                        related to the Account.</li>
                </ol>

                <div class="rol-heading">Reliance and Finality</div>
                <p class="rol-p">Provider agrees that Patient, Injury Counsel, and any and all agents and assignees thereof, may rely upon
                    this Release as final.</p>

                <div class="rol-witness">
                    <span class="rol-bold">IN WITNESS WHEREOF,</span> Provider executes this Release below, intending to be legally bound as of the date set forth below.
                </div>

                <!-- Provider Execution -->
                <div class="rol-sig-block">
                    <div class="rol-sig-block-heading">Provider Execution:</div>
                    <table class="rol-sig-table">
                        <tr>
                            <td style="width:50%;padding-right:10px;">
                                <span class="rol-sig-label">Provider Name</span>
                                <span class="rol-sig-line"></span>
                            </td>
                            <td style="width:50%;padding-left:10px;">
                                <span class="rol-sig-label">Authorized Agent</span>
                                <span class="rol-sig-line"></span>
                            </td>
                        </tr>
                    </table>
                    <table class="rol-sig-table">
                        <tr>
                            <td style="width:50%;padding-right:10px;">
                                <span class="rol-sig-label">Title</span>
                                <span class="rol-sig-line"></span>
                            </td>
                            <td style="width:50%;padding-left:10px;">
                                <span class="rol-sig-label">Date</span>
                                <div class="inline-date-picker">
                                    <app-date-picker placeholder="Select date" [showLabel]="false"
                                        [(ngModel)]="state.selectedDate"></app-date-picker>
                                </div>
                            </td>
                        </tr>
                    </table>
                    <table class="rol-sig-table" style="margin-bottom:0;">
                        <tr><td>
                            <span class="rol-sig-label">Signature</span>
                            <canvas #sigCanvas class="rol-sig-canvas"
                                [class.has-sig]="!state.isDrawEmpty"
                                (mousedown)="mouseDown.emit($event)"
                                (mousemove)="mouseMove.emit($event)"
                                (mouseup)="mouseUp.emit()"
                                (mouseleave)="mouseUp.emit()"
                                (touchstart)="touchStart.emit($event)"
                                (touchmove)="touchMove.emit($event)"
                                (touchend)="touchEnd.emit()">
                            </canvas>
                        </td></tr>
                    </table>
                </div>
            </div><!-- /.rol-body -->

            <div class="rol-footer">
                <span>E.A.S.Y. Liens, LLC &mdash; Confidential</span>
                <span>Release of Lien &amp; Authority to Distribute &mdash; Page 1 of 2</span>
            </div>
        </div><!-- /.rol-page -->
    </div><!-- /.doc-card -->

</div>
